import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req } from '@nestjs/common';
import { ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { CommentsService } from './comments.service';
import { AllCommentsResponseModel, CommentsResponseModel } from './dto/comments-response-module';
import { CommentsDTO, GetCommentsByPostId, PaginationDto } from './dto/comments.dto';
@ApiTags('Comments')
@Controller('comments')
export class CommentsController {
    constructor (
        private commentsService:CommentsService
    ) {}
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createComment')
    @ApiQuery({name:'apiVersion'})
    async createComment(@Query() queryParams, @Body() commentsDTO:CommentsDTO, @Req() request: Request): Promise<CommentsResponseModel> {
        try {
            return await this.commentsService.createComment(queryParams, commentsDTO, request);
        } catch (error) {
            return errorHandler(CommentsResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getComments/:PostId')
    @ApiParam({name:'PostId'})
    @ApiQuery({name:'apiVersion'})
   
    async getCommentsByPostId(@Query()pageDto:PaginationDto,@Param('PostId') PostId,@Req()request: Request): Promise<AllCommentsResponseModel> {
        try {
            return await this.commentsService.getCommentsByPostId(pageDto, PostId,request);
        } catch (error) {
            return errorHandler(AllCommentsResponseModel, error);
        }
    }

}
